module.exports = __webpack_public_path__ + "static/breakpoints-d430e54c8caa56bad63127ea48a9b798.png";